import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import { useLocation, useNavigate } from "react-router-dom";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import ChallanCard from "./VendorChallanCard";
import ChallanTable from "./VendorChallanTable";
import Swal from "sweetalert2";


const VendorChallanPage = () => {
  const { is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables,
  );
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [productData, setProductData] = useState(null);
  const [challanData, setChallanData] = useState(null);
  const [billResponse, setBillResponse] = useState(null);
  const [challanDataCopy, setChallanDataCopy] = useState(null);
  const [challanCopy, setChallanCopy] = useState(null);
  const [printData, setPrintData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const handlePopup = () => {
    if (isCreate === true) {
      clear();
    }
    dispatch(rSetShowFab(isCreate));
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const handleEditData = (data) => {
    dispatch(rSetShowFab(isCreate));
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
  };

  const clear = () => {
    setEditData({});
  };

  useEffect(() => {
    if (location.state?.selectedCustomer) {
      setSelectedCustomer(location.state.selectedCustomer);
    }
    if (location.state?.productData) {
      setProductData(location.state.productData);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.challanData) {
      setChallanData(location.state.challanData);
      setBillResponse(location.state.billResponse);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.challanDataCopy) {
      setChallanDataCopy(location.state.challanDataCopy);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.state]);

  useEffect(() => {
    if (challanData || challanDataCopy) {
      window.scrollTo({ top: 0 });
      setIsEdit(false);
      setIsCreate(true);
    }
  }, [challanData, challanDataCopy]);

  useEffect(() => {
    if (selectedCustomer) {
      window.scrollTo({ top: 0 });
      setIsEdit(false);
      setIsCreate(true);
    }
  }, [selectedCustomer]);

  const handleCopyChallan = (data) => {
    window.scrollTo({ top: 0 });
    setIsEdit(false);
    setIsCreate(true);
    setChallanCopy(data);
  };

  const handlePrintPopup = (data) => {
    Swal.fire({
      title: "Print Job Work?",
      text: "Do you want to continue printing this job work?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#1976d2",
    }).then((result) => {
      if (result.isConfirmed) {
        setPrintData(data);
      }
    });
  };

  return (
    <>
      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"Job Work"}
          handlePopup={handlePopup}
          isEdit={isEdit}
          create={isCreate}
          showCreate={Boolean(
            is_super || is_admin || permissions?.includes(61),
          )}
        />

        {isCreate && (
          <ChallanCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            clear={clear}
            setIsChanged={setIsChanged}
            isChanged={isChanged}
            isCreate={isCreate}
            setIsCreate={setIsCreate}
            selectedCustomerr={selectedCustomer}
            productData={productData}
            setProductData={setProductData}
            setSelectedCustomerr={setSelectedCustomer}
            challanData={challanData}
            setChallanData={setChallanData}
            billResponse={billResponse}
            setBillResponse={setBillResponse}
            challanDataCopy={challanDataCopy}
            setChallanDataCopy={setChallanDataCopy}
            challanCopy={challanCopy}
            setChallanCopy={setChallanCopy}
            printpopup={handlePrintPopup}
            entityType="supplier"
          />
        )}
        <ChallanTable
          handleEditData={handleEditData}
          isChanged={isChanged}
          handleCopyChallan={handleCopyChallan}
          data={printData}
          entityType="supplier"
        />
      </Container>
    </>
  );
};

export default memo(VendorChallanPage);
